(function () {
  function normalize(value) {
    return (value || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function initCollection(root) {
    if (root.dataset.collectionBound === 'true') return;
    root.dataset.collectionBound = 'true';

    var drawer = root.querySelector('[data-filter-drawer]');
    var backdrop = root.querySelector('.mb-facets-backdrop');
    var search = root.querySelector('[data-product-search]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-commerce-card]'));
    var treatmentButtons = Array.prototype.slice.call(root.querySelectorAll('[data-treatment-filter]'));
    var priceInputs = Array.prototype.slice.call(root.querySelectorAll('[data-client-price] input'));
    var count = root.querySelector('[data-visible-count]');
    var empty = root.querySelector('[data-client-empty]');
    var activeTreatment = 'all';
    var activePrice = 'all';

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      if (backdrop) backdrop.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (backdrop) backdrop.hidden = true;
      document.documentElement.style.overflow = '';
    }

    function priceMatches(price) {
      if (activePrice === 'all') return true;
      if (activePrice === '0-6000') return price <= 6000;
      if (activePrice === '6000-15000') return price > 6000 && price <= 15000;
      if (activePrice === '15000-up') return price > 15000;
      return true;
    }

    function applyClientFilters() {
      var term = normalize(search ? search.value : '');
      var visible = 0;
      cards.forEach(function (card) {
        var treatment = card.dataset.treatment || '';
        var title = normalize(card.dataset.productTitle || '');
        var price = parseInt(card.dataset.price || '0', 10);
        var matches = (activeTreatment === 'all' || treatment === activeTreatment) && priceMatches(price) && (!term || title.indexOf(term) !== -1);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (count) count.textContent = 'Mostrando ' + visible + (visible === 1 ? ' produto' : ' produtos');
      if (empty) empty.hidden = visible !== 0;
    }

    root.querySelectorAll('[data-filter-open]').forEach(function (button) { button.addEventListener('click', openDrawer); });
    root.querySelectorAll('[data-filter-close]').forEach(function (button) { button.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeDrawer(); });

    treatmentButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeTreatment = button.dataset.treatmentFilter;
        treatmentButtons.forEach(function (item) { item.classList.toggle('is-active', item === button); });
        applyClientFilters();
      });
    });
    priceInputs.forEach(function (input) {
      input.addEventListener('change', function () { activePrice = input.value; applyClientFilters(); });
    });
    if (search) search.addEventListener('input', applyClientFilters);

    var sort = root.querySelector('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.assign(url.toString());
      });
    }

    var reset = root.querySelector('[data-reset-client-filters]');
    if (reset) {
      reset.addEventListener('click', function () {
        activeTreatment = 'all';
        activePrice = 'all';
        if (search) search.value = '';
        treatmentButtons.forEach(function (button) { button.classList.toggle('is-active', button.dataset.treatmentFilter === 'all'); });
        priceInputs.forEach(function (input) { input.checked = input.value === 'all'; });
        applyClientFilters();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-collection-commerce]').forEach(initCollection);
  });
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-collection-commerce]').forEach(initCollection);
  });
})();
